module.exports = __webpack_public_path__ + "img/infographic_us.973111ee.jpg";